import { graphql } from "../gql";

export const featureFlagDynamicQueryDoc = graphql(`
  query featureFlagDynamic(
    $key: String!
    $type: String!
    $defaultValue: JSON!
  ) {
    featureFlagDynamic(key: $key, type: $type, defaultValue: $defaultValue) {
      key
      type
      resolvedValue
      defaultValue
      isDefault
    }
  }
`);
